var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSupportWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z",
    stroke: "white",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22.6667V22.68",
    stroke: "white",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 18C15.9755 17.5672 16.0922 17.1381 16.3327 16.7773C16.5732 16.4166 16.9244 16.1438 17.3333 16C17.8345 15.8083 18.2843 15.503 18.6474 15.1079C19.0105 14.7129 19.277 14.239 19.4258 13.7234C19.5746 13.2079 19.6017 12.6649 19.505 12.1372C19.4083 11.6094 19.1904 11.1113 18.8684 10.682C18.5465 10.2528 18.1293 9.90411 17.6497 9.66349C17.1702 9.42287 16.6413 9.29685 16.1047 9.29536C15.5682 9.29387 15.0386 9.41695 14.5577 9.65491C14.0768 9.89287 13.6577 10.2392 13.3333 10.6667",
    stroke: "white",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupportWhite);
export default __webpack_public_path__ + "static/media/Icon_Support_White.f91d7489d82a97841ecbf90a80417ed0.svg";
export { ForwardRef as ReactComponent };